import RawApiClient, {
  throwNon200ResponseTransformer,
  parseBodyAsJsonResponseTransformer,
} from "./RawApiClient";
import getEnvironmentRequestTransformer from "./getEnvironmentRequestTransformer";
/**
 * Internal api clients target the internal-appshell-server proxy
 * rather than the planweb proxy. The internal proxy attaches priviledged tokens
 * to proxied requests so it requires the user to be a plangrid admin.
 */
const rawInternalCacaClient = new RawApiClient({
  requestTransformers: [getEnvironmentRequestTransformer("internal-caca")],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
  ],
});
export default rawInternalCacaClient;
